<template>
  <div class="page_accountsReceivable">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px" size="small">
            <el-form-item label="归属项目">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" clearable filterable style="width: 180px;">
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="归属部门:">
              <el-cascader v-model="dedpartName" size="small" :props="props" clearable filterable :options="departList" placeholder="" @change="departChange" style="width: 180px;"></el-cascader>
            </el-form-item>
            <el-form-item label="客户名称" v-if="activeName=='GetAccountReceiProjectList'">
              <el-input v-model="listQuery.customerName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="发票号码" v-if="activeName=='GetAccountReceInvoiceList' || activeName=='GetAccountReceiWriteList'">
              <el-input v-model="listQuery.invoiceNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="归属月" v-if="activeName=='GetAccountReceiProjectAttrMonthList'" size="small">
              <el-date-picker v-model="listQuery.attrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px" size="small">
          <el-form-item label="归属月" v-if="activeName=='GetAccountReceiProjectList'||activeName=='GetAccountReceiWriteList'" size="small">
            <el-date-picker v-model="listQuery.attrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="归属月" v-if="activeName=='GetAccountReceiWriteList'">
            <el-input v-model="listQuery.customerInvoiceHeader" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="认领编号" v-if="activeName=='GetAccountReceiWriteList'">
            <el-input v-model="listQuery.claimNo " size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="开票编号" v-if="activeName=='GetAccountReceInvoiceList'">
            <el-input v-model="listQuery.applicaNum" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="客户开票抬头" v-if="activeName=='GetAccountReceInvoiceList'">
            <el-input v-model="listQuery.attrMonth" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="我方开票抬头" v-if="activeName=='GetAccountReceInvoiceList'">
            <el-input v-model="listQuery.ourInvoiceEntity" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
          <el-form-item label="业绩归属人">
            <el-select v-model="listQuery.strAchieveowner" placeholder="" clearable style="width: 180px;" filterable>
              <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合伙人">
            <el-select v-model="listQuery.strpartner" placeholder="" clearable style="width: 180px;" filterable>
              <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客服">
            <el-select v-model="listQuery.service" placeholder="" clearable style="width: 180px;" filterable>
              <el-option v-for="(item,index) in customerList" :key="index" :value="item.Username"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易类型">
            <el-select v-model="listQuery.transactionType" placeholder="" filterable clearable size="small" style="width: 180px;">
              <el-option label="外部交易" value="1"></el-option>
              <el-option label="内部交易" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票开始时间" v-if="activeName=='GetAccountReceInvoiceList'">
            <el-date-picker v-model="listQuery.CreateTimeStart" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="开票结束时间" v-if="activeName=='GetAccountReceInvoiceList'">
            <el-date-picker v-model="listQuery.CreateTimeEnd" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>应收账款</el-breadcrumb-item>
          <el-breadcrumb-item>{{tabName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="按项目" name="GetAccountReceiProjectList"></el-tab-pane>
          <el-tab-pane label="按开票" name="GetAccountReceInvoiceList"></el-tab-pane>
          <el-tab-pane label="按归属月" name="GetAccountReceiProjectAttrMonthList"></el-tab-pane>
          <el-tab-pane label="核销记录" name="GetAccountReceiWriteList"></el-tab-pane>
          <el-tab-pane label="预收款" name="GetPrepaymentPageList"></el-tab-pane>
        </el-tabs>

        <div class="ftabBtn flex">
          <!-- <el-button type="warning" size="small">批量到款核销</el-button> -->
          <el-button type="primary" size="small" @click="expList" :loading="isExping">导出</el-button>
          <div class="flex aic" style="margin-left: 30px;" v-if="activeName!='GetAccountReceiWriteList' && activeName!='GetPrepaymentPageList'">
            <div class="sumItem">开票笔数： <span class="sumNum">{{ totalCount }}</span></div>
            <div class="sumItem">开票金额合计： <span class="sumNum">￥{{  formatNumber(totalInvoiceAmount) }}</span></div>
            <div class="sumItem">回款金额合计： <span class="sumNum">￥{{  formatNumber(totalCollectionAmount) }}</span></div>
            <div class="sumItem">应收账款合计： <span class="sumNum">￥{{  formatNumber(totalAccountReceiv) }}</span></div>
          </div>
        </div>
        <el-table :data="tableData" :show-overflow-tooltip="true" border class="doc_table" style="width:100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <el-table-column key="1" label="序号" min-width="50" align="center" fixed="left">
            <template slot-scope="{$index}">{{ (listQuery.pageModel.Page - 1) * listQuery.pageModel.Rows + ($index + 1) }}</template>
          </el-table-column>
          <template v-for="item in tableTitle">
            <el-table-column :prop="item.prop" :key="item.index" :label="item.label" align="center" :min-width="item.width ? item.width : 100" :show-overflow-tooltip="true" :fixed="item.isfixed">
              <template slot-scope="{row}">
                <span v-if="item.type=='time'">{{ row[item.prop] ? row[item.prop].replace('T',' ') : '' }}</span>
                <span v-else>{{ row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
          <el-table-column label="核销方式" min-width="100" align="center" v-if="activeName=='GetAccountReceiWriteList'">
            <template slot-scope="{row}">{{ row.writeMethod == '1' ? '到款核销' : row.writeMethod == '2' ? '直接核销' : row.writeMethod == '3' ? '发票作废' : row.writeMethod == '4' ? '撤销认领' : '核销撤回' }}</template>
          </el-table-column>
          <el-table-column label="交易类型" min-width="100" align="center" v-if="activeName=='GetAccountReceiProjectList' || activeName=='GetAccountReceInvoiceList' || activeName=='GetAccountReceiWriteList'">
            <template slot-scope="{row}">{{ row.transactionType == '1' ? '外部交易' : row.transactionType == '2' ? '内部交易' : '' }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="140" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" v-if="activeName == 'GetAccountReceInvoiceList'" @click="paymentWriteoff(row)">到款核销</el-button>
                <el-button type="text" v-if="activeName == 'GetAccountReceInvoiceList' && checkPermission(['AR_directHandle'],permissionLists)" @click="directHandle(row)">直接核销</el-button>
                <el-popconfirm title="请确定是否撤销" @confirm="revoke(row)" v-if="activeName == 'GetAccountReceiWriteList'">
                  <el-button type="text" slot="reference" style="margin-left: 10px;">撤销</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="到款核销" :visible.sync="showWriteoff" width="1100px">
      <div class="receivableTitle">应收账款： <span class="receivableSum">￥{{ formatNumber(receivableSum) }}</span></div>
      <el-table :data="paymentData" class="ele_table" style="width:100%" max-height="500px">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="paymentNum" label="到款编号" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="bankSerialNumber" label="银行流水号" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="bankTransactionDate" label="到款时间" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="oppositeName" label="对方户名" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="accountName" label="我方户名" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="attrMonth" label="归属月" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="amountClaime" label="已认领到款" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column prop="advancePay" label="可用核销金额" :show-overflow-tooltip="true" align="center" min-width="100">
        </el-table-column>
        <el-table-column label="本次核销金额" align="center" width="140">
          <template slot-scope="{row}">
            <el-input v-model="row.writeAmount" size="small" clearable style="width:120px" @blur="checkMax(row)"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showWriteoff = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" :loading="isBtnLoading" @click="confrimWrite">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="直接核销" :visible.sync="showDirectVerification" width="550px">
      <el-form :model="direForm" :rules="rules" ref="direForm" label-width="130px">
        <el-form-item label="待核销应收账款：">
          <div class="inspectItem">￥{{collectionAmount}}</div>
        </el-form-item>
        <el-form-item label="本次核销金额：" prop="CurrentWriteAmount">
          <el-input v-model="direForm.CurrentWriteAmount" size="small" type="number" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="direForm.Remark" size="small" style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDirectVerification = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmDirectHandle" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    e
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import moment from 'moment';
  export default {
    data() {
      return {
        listQuery: {
          pageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 1
            }]
          },
          ourInvoiceEntity: '', //我方开票主体
          projectName: '',
          customerName: '',
          strAchieveowner: '',
          strpartner: '',
          strDep2: '',
          service: '',
          CreateTimeStart: '',
          CreateTimeEnd: '',
          attrMonth: '', //归属月
          transactionType: '', ///交易类型1.外部交易2.内部交易
          customerInvoiceHeader: '' //客户开票抬头
        },
        dedpartName: '', //部门
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        departList: [], //部门列表
        showDropScreen: -1,
        activeName: 'GetAccountReceiProjectList',
        multipleSelection: [],
        tableData: [],
        tableTitle: [],
        customerList: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        isExping: false,
        isBtnLoading: false,
        permissionLists: [],
        receivableSum: 0, //应收账款合计
        legList: [],
        totalAccountReceiv: 0, //应收账款合计
        totalCollectionAmount: 0, //回款金额合计
        totalInvoiceAmount: 0, //开票金额合计
        showWriteoff: false,
        tabName: '按项目',
        showDirectVerification: false, //直接核销
        direForm: {
          Id: '',
          CurrentWriteAmount: '',
          Remark: '',
        },
        collectionAmount: 0, //应收账款
        rules: {
          CurrentWriteAmount: {
            required: true,
            message: '请输入本次核销金额',
            trigger: 'blur'
          },
        },
        paymentData: [], //到款核销列表
      }
    },
    created() {
      this.getButtonPower();
      this.getList();
      this.getProList();
      this.getDepartList();
      this.getlegalsubjectlist();
      this.getMemberList();
    },
    mounted() {
      this.tableTitle = [{
          label: '项目/部门',
          prop: 'projectName',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '客户名称',
          prop: 'customerName',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '业绩归属人',
          prop: 'strAchieveowner',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '合伙人',
          prop: 'strpartner',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '服务部门',
          prop: 'strDep2',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '客服',
          prop: 'service',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '开票金额',
          prop: 'invoiceAmount',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '回款金额',
          prop: 'collectionAmount',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '应收账款',
          prop: 'accountReceiv',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '预收款',
          prop: '',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '最长账龄',
          prop: 'maxAccountAge',
          width: '',
          isfixed: false,
          type: ''
        },
        {
          label: '备注',
          prop: 'remark',
          width: '',
          isfixed: false,
          type: ''
        }
      ];
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/accountsReceivable',
          powerEnName: 'accountsReceivable'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let str = `GetSocialSubjectOfLegalAffairs?keyword=&pagesize=1000`
        xz.BasicGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      currentChange(val) {
        this.listQuery.pageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.Page = 1;
        this.listQuery.pageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.Page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, this.activeName).then(res => {
          if (res.status == 'ok') {
            if (this.activeName == 'GetAccountReceiWriteList' || this.activeName == 'GetPrepaymentPageList') {
              this.tableData = res.data.data;
              this.totalCount = res.data.pageModel.totalCount;
            } else {
              this.tableData = res.data.result.data;
              this.totalCount = res.data.result.pageModel.totalCount;
              this.totalAccountReceiv = res.data.totalAccountReceiv;
              this.totalCollectionAmount = res.data.totalCollectionAmount;
              this.totalInvoiceAmount = res.data.totalInvoiceAmount;
            }
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      // 获取客服列表
      getMemberList() {
        let data = {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "",
          strstation: "",
          strorgancode: "",
        }
        xz.getauthUserInfoByorgancode(data).then((res) => {
          if (res.status == "ok") {
            this.customerList = res.msg;
          } else {
            this.customerList = [];
          }
        });
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab(tab) {
        this.tabName = tab.label;
        if (this.activeName == 'GetPrepaymentPageList') {
          this.listQuery = {
            pageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: [{
                property: 'bankTransactionDate',
                order: 1
              }]
            },
            roletype: this.roletype,
            userid: Cookies.get("userid-b"),
            projectId: null,
            vestingMonth: '',
            advancePayMin: null,
            emainingAvailableCreditMin: null,
            bankTransactionDate1: "",
            bankTransactionDate2: ""
          }
          this.tableTitle = [{
              label: '认领编号',
              prop: 'claimNum',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '到款编号',
              prop: 'paymentNum',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '银行流水号',
              prop: 'transactionSerialNumber',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '到款金额',
              prop: 'incurredAmount',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '认领金额',
              prop: 'amountClaime',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '预收款',
              prop: 'advancePay',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '认领项目或部门',
              prop: 'projectName',
              width: '140',
              isfixed: false,
              type: ''
            },
            {
              label: '归属月',
              prop: 'vestingMonth',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '认领人',
              prop: 'claimant',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '认领时间',
              prop: 'createTime',
              width: '155',
              isfixed: false,
              type: 'time'
            },
            {
              label: '对方户名',
              prop: 'oppositeName',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '对方账户',
              prop: 'oppositeAccount',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '我方户名',
              prop: 'accountName',
              width: '',
              isfixed: false,
              type: ''
            },
            {
              label: '我方银行账户',
              prop: 'accountNo',
              width: '150',
              isfixed: false,
              type: ''
            },
            {
              label: '到款时间',
              prop: 'bankTransactionDate',
              width: '155',
              isfixed: false,
              type: 'time'
            },
          ];
        } else {
          this.listQuery = this.$options.data.call(this).listQuery;
          if (this.activeName == 'GetAccountReceiProjectList') {
            this.tableTitle = [{
                label: '项目/部门',
                prop: 'projectName',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '客户名称',
                prop: 'customerName',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '业绩归属人',
                prop: 'strAchieveowner',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '合伙人',
                prop: 'strpartner',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '服务部门',
                prop: 'strDep2',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '客服',
                prop: 'service',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '开票金额',
                prop: 'invoiceAmount',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '回款金额',
                prop: 'collectionAmount',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '应收账款',
                prop: 'accountReceiv',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '预收款',
                prop: '',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '最长账龄',
                prop: 'maxAccountAge',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '备注',
                prop: 'remark',
                width: '',
                isfixed: false,
                type: ''
              }
            ];
          } else if (this.activeName == 'GetAccountReceInvoiceList') {
            this.tableTitle = [{
              label: '开票申请编号',
              prop: 'applicaNum',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '发票号码',
              prop: 'invoiceNum',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '开票时间',
              prop: 'createTime',
              width: '155',
              isfixed: false,
              type: 'time'
            }, {
              label: '开票金额',
              prop: 'invoiceAmount',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '回款金额',
              prop: 'collectionAmount',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '应收账款',
              prop: 'accountReceiv',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '客户开票抬头',
              prop: 'customerInvoiceHeader',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '我方开票主体',
              prop: 'ourInvoiceEntity',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '项目/部门',
              prop: 'projectName',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '客户名称',
              prop: 'customerName',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '业绩归属人',
              prop: 'strAchieveowner',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '合伙人',
              prop: 'strpartner',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '服务部门',
              prop: 'strDep2',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '客服',
              prop: 'service',
              width: '',
              isfixed: false,
              type: ''
            }, {
              label: '备注',
              prop: 'remark',
              width: '',
              isfixed: false,
              type: ''
            }]
          } else if (this.activeName == 'GetAccountReceiProjectAttrMonthList') {
            this.tableTitle = [{
                label: '归属月',
                prop: 'attrMonth',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '项目/部门',
                prop: 'projectName',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '客户名称',
                prop: 'customerName',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '业绩归属人',
                prop: 'strAchieveowner',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '合伙人',
                prop: 'strpartner',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '服务部门',
                prop: 'strDep2',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '客服',
                prop: 'service',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '开票金额',
                prop: 'invoiceAmount',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '回款金额',
                prop: 'collectionAmount',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '应收账款',
                prop: 'accountReceiv',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '预收款',
                prop: '',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '最长账龄',
                prop: 'maxAccountAge',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '备注',
                prop: 'remark',
                width: '',
                isfixed: false,
                type: ''
              }
            ];
            let now = new Date();
            this.listQuery.attrMonth = moment(now).subtract(1, 'months').format('YYYY-MM');
          } else if (this.activeName == 'GetAccountReceiWriteList') {
            this.tableTitle = [{
                label: '核销编号',
                prop: '',
                width: '',
                isfixed: false,
                type: ''
              },
              {
                label: '开票申请编号',
                prop: 'applicaNum',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '发票号码',
                prop: 'invoiceNum',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '开票金额',
                prop: 'invoiceAmount',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '应收账款',
                prop: 'accountReceiv',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '到款编号',
                prop: 'arrivalNo',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '认领到款编号',
                prop: 'claimNo',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '认领到款金额',
                prop: 'amountClaimed',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '本次核销金额',
                prop: 'currentWriteAmount',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '核销时间',
                prop: 'createTime',
                width: '155',
                isfixed: false,
                type: 'time'
              }, {
                label: '归属月',
                prop: 'attrMonth',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '核销人',
                prop: 'writtenBy',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '发票申请人',
                prop: 'invoiceApplicer',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '项目/部门',
                prop: 'projectName',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '服务部门',
                prop: 'strDep2',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '业绩归属人',
                prop: 'strAchieveowner',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '合伙人',
                prop: 'strpartner',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '客服',
                prop: 'service',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '对方户名',
                prop: 'oppositeName',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '对方银行/账户',
                prop: 'oppositeAccount',
                width: '140',
                isfixed: false,
                type: ''
              }, {
                label: '我方户名',
                prop: 'accountName',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '我方银行/账户',
                prop: 'accountNo',
                width: '160',
                isfixed: false,
                type: ''
              }, {
                label: '电子回单',
                prop: '',
                width: '',
                isfixed: false,
                type: ''
              }, {
                label: '到款时间',
                prop: 'bankTransactionDate',
                width: '155',
                isfixed: false,
                type: 'time'
              }, {
                label: '开票时间',
                prop: 'invoiceTime',
                width: '155',
                isfixed: false,
                type: 'time'
              }, {
                label: '核销备注',
                prop: 'remark',
                width: '',
                isfixed: false,
                type: ''
              },
            ];
          }
        }
        this.getList();
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', localStorage.loginRoletype, {
          strIsDisable: 1
        }).then(res => {
          if (res.status == 'ok') {
            this.departList = res.msg.parent[0].children
          } else {
            this.departList = []
          }
        })
      },
      // 选择归属部门
      departChange(val) {
        // console.log('111', val)
        if (val) {
          this.listQuery.strDep2 = val[val.length - 1]
        } else {
          this.listQuery.strDep2 = ''
        }
      },
      formatNumber(value) {
        if (!value && value !== 0) return '0';
        return Number(value).toLocaleString(); // 每三位加逗号
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      directHandle(row) {
        this.isBtnLoading = false;
        this.collectionAmount = row.collectionAmount;
        this.direForm = {
          Id: row.id,
          CurrentWriteAmount: '',
          Remark: '',
        };
        this.showDirectVerification = true;
      },
      confirmDirectHandle() {
        this.$refs.direForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            let str = `?Id=${this.direForm.Id}&CurrentWriteAmount=${this.direForm.CurrentWriteAmount}&Remark=${this.direForm.Remark}`
            xz.ArdCurStatGetFun('DirectWriteAccountRecei', str).then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.getList();
                this.showDirectVerification = false;
                this.$message.success("操作成功！");
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      expList() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        // delete d.pageModel;
        let pagename = `E${this.activeName}`
        xz.ArdCurStatExp(d, pagename).then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = `${this.activeName}列表.xlsx`;
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      // 撤销
      revoke(row) {
        this.loading = true;
        let str = `?writeRecordId=${row.id}`
        xz.ArdCurStatGetFun('RevertWriteRecord', str).then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.getList();
            this.$message.success("操作成功！");
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      //到款核销
      paymentWriteoff(row) {
        this.receivableSum = row.accountReceiv;
        let str = `?Id=${row.id}`
        xz.ArdCurStatGetFun('GetPayVeriDetailsAdvancePay', str).then(res => {
          if (res.status == 'ok') {
            res.data.forEach(element => {
              this.$set(element, 'writeAmount', 0)
            });
            this.paymentData = res.data;
            this.showWriteoff = true;
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      checkMax(row) {
        if (row.writeAmount > row.advancePay) {
          this.$message.error('核销金额不能大于可用核销金额！');
          this.$set(row, 'writeAmount', 0);
        } else if (row.writeAmount < 0) {
          this.$message.error('核销金额不能小于0！');
          this.$set(row, 'writeAmount', 0)
        }
      },
      confrimWrite() {
        let canWrite = true;
        let arr = [];
        this.paymentData.forEach(element => {
          if (!element.writeAmount || element.writeAmount <= 0) {
            canWrite = false;
          }
          let item = {
            claimRecordId: element.claimRecordId,
            invoiceDetailId: element.invoiceDetailId,
            remark: '',
            writeAmount: element.writeAmount
          }
          arr.push(item);
        });
        if (canWrite) {
          this.isBtnLoading = true;
          xz.ArdCurStat(arr, 'AssignWriteOffs').then(res => {
            if (res.status == 'ok') {
              this.isBtnLoading = false;
              this.$message.success('核销成功！');
              this.showWriteoff = false;
            }
          })
        } else {
          this.$message.error('请填写核销金额！')
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }

  .errTips {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .sumItem {
    margin-right: 20px;
  }

  .sumNum {
    font-weight: 600;
  }

  .receivableTitle {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .receivableSum {
    color: red;
    font-weight: 600;
  }
</style>
<style>
  .page_accountsReceivable .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_accountsReceivable .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_accountsReceivable .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_accountsReceivable .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_accountsReceivable .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_accountsReceivable .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_accountsReceivable .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_accountsReceivable .el-checkbox__label {
    padding-left: 3px;
  }

  .page_accountsReceivable .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .el-tooltip__popper {
    max-width: 800px;
  }
</style>